import { Color } from "three";
import { BasePanel } from "./BasePanel";
import VUtil from "../VUILib/VUtils.js";
import { EditPanel_Scene } from "./EditPanel_Scene.js";
import { EditPanel_Terrain } from "./EditPanel_Terrain.js";
import { EditPanel_Way } from "./EditPanel_Way.js";
import { EditPanel_Material } from "./EditPanel_Material.js";
import { EditPanel_Model } from "./EditPanel_Model.js";

const leftbgPath = "/assets/vrUI/Editpanel/leftBg.png";
const rightbgPath = "/assets/vrUI/Editpanel/rightBg.png";
const btn_selectPath = "/assets/vrUI/Editpanel/btn_select.png";
const btn_hoverPath = "/assets/vrUI/Editpanel/btn_hover.png";
const closeIconPath = "/assets/vrUI/common/close.png";

const sceneIconPath = "/assets/vrUI/Editpanel/sceneIcon.png";
const materialIconPath = "/assets/vrUI/Editpanel/materialIcon.png";
const wayIconPath = "/assets/vrUI/Editpanel/wayIcon.png";
const modelIconPath = "/assets/vrUI/Editpanel/modelIcon.png";
const terrainIconPath = "/assets/vrUI/Editpanel/terrainIcon.png";

export class EditPanel extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
  }

  async init() {
    const width = 0.5;
    const height = 0.8;

    const leftBg = await this.manager.loadManager.loadTexture(leftbgPath);
    const rightBg = await this.manager.loadManager.loadTexture(rightbgPath);
    const selectBg = await this.manager.loadManager.loadTexture(btn_selectPath);
    const hoverBg = await this.manager.loadManager.loadTexture(btn_hoverPath);

    const sceneIcon = await this.manager.loadManager.loadTexture(sceneIconPath);
    const materialIcon = await this.manager.loadManager.loadTexture(
      materialIconPath
    );
    const wayIcon = await this.manager.loadManager.loadTexture(wayIconPath);
    const modelIcon = await this.manager.loadManager.loadTexture(modelIconPath);
    const terrainIcon = await this.manager.loadManager.loadTexture(
      terrainIconPath
    );

    // left panel
    const container = this.uilib.createContainer({
      color: 0xffffff,
      map: leftBg,
      opacity: 1,
      width: width,
      height: height,
      radius: 0.02,
      dragable: false,
    });
    //bg.scale.set(0.5, 0.5, 0.5);
    this.uilib.addUIToScene(container);
    container.position.x = -1;
    container.position.y = -0.7;
    container.visible = this._visible;
    this.uiElements.push(container);

    // right panel
    const container2 = this.uilib.createContainer({
      color: 0xffffff,
      map: rightBg,
      opacity: 1,
      width: height * 3,
      height: height,
      radius: 0.02,
      dragable: false,
    });

    // close btn
    const closeIcon = await this.manager.loadManager.loadTexture(closeIconPath);
    const closeBtn = this.uilib.createBtn({
      map: closeIcon,
      text: "",
      color: "#ffffff",
      width: 0.1,
      height: 0.1,
      radius: 0,
      stateChangeColor: {
        hover: "#A8B4DB",
        click: "#1A4086",
        normal: "#ffffff",
      },
    });
    // closeBtn.addHoverEnterEvent((obj) => {
    //   obj.material.color = new Color("#6275B5");
    // });
    // closeBtn.addHoverExitEvent((obj) => {
    //   obj.material.color = new Color("#A8B4DB");
    // });
    closeBtn.addClickEvent((obj) => {
      this.closePanel();
    });
    container.add(closeBtn);
    closeBtn.position.z = 0.001;
    closeBtn.position.y = 0.425;
    closeBtn.position.x = 2.375;

    container.add(container2);
    container2.position.x = 1.35;

    this.itemInfos = [
      {
        icon: sceneIcon,
        name: "场景模型",
      },
      {
        icon: terrainIcon,
        name: "地形",
      },
      {
        icon: materialIcon,
        name: "材质库",
      },

      {
        icon: modelIcon,
        name: "模型库",
      },
      {
        icon: wayIcon,
        name: "道路",
      },
    ];

    this.selectIndex = 0;

    this.uiObjs = [];
    for (var i = 0; i < this.itemInfos.length; i++) {
      const tempContainer = this.uilib.createContainer({
        width: width * 0.7,
        height: 0.12,
        radius: 0.02,
        dragable: false,
        color: 0xffffff,
        map: hoverBg,
        opacity: i === this.selectIndex ? 1 : 0.0,
      });
      const icon = this.uilib.createImage({
        map: this.itemInfos[i].icon,
        color: 0xafbbe3,
        width: 0.1,
        height: 0.1,
        radius: 0,
      });
      tempContainer.add(icon);
      icon.material.transparent = false;

      icon.position.z = 0.001;
      icon.position.x = -0.095;
      const nameText = this.uilib.createText({
        text: this.itemInfos[i].name,
        textColor: 0xafbbe3,
        textSize: 0.045,
        font: "bold",
        align: "left",
      });
      tempContainer.add(nameText);
      nameText.position.z = 0.001;
      nameText.position.x = -0.025;
      tempContainer.position.z = 0.001;
      tempContainer._editPanelIndex = i;
      tempContainer._icon = icon;
      tempContainer._nameText = nameText;
      this.uiObjs.push(tempContainer);
    }

    // tabcontrol
    this.tabControl = this.uilib.createTabControl({
      selectImage: selectBg,
      width: width,
      height: height,
      radius: 0.0,
      axis: "verticle",
      gap: 0.01,
      opacity: 0,
      uiObjs: this.uiObjs,
      defaultIndex: this.selectIndex,
    });
    this.tabControl.addOnElementHoverEnterEvent((obj) => {
      obj.material.opacity = 1;
      obj._icon.material.color = new Color(0xffffff);
      if (obj._nameText.children.length > 0)
        VUtil.setTextColor(obj._nameText.children[0], 0xffffff);
    });
    this.tabControl.addOnElementHoverExitEvent((obj) => {
      if (this.selectIndex != obj._editPanelIndex) obj.material.opacity = 0.0;
      obj._icon.material.color = new Color(0xafbbe3);
      if (obj._nameText.children.length > 0)
        VUtil.setTextColor(obj._nameText.children[0], 0xafbbe3);
    });
    this.tabControl.addOnElementClickEvent((obj, index) => {
      this.onClickBtn(obj, index);
    });
    container.add(this.tabControl);
    this.tabControl.position.y = -0.075;
    this.tabControl.position.x = 0.075;

    this.panels = [];
    // 场景模型编辑面板
    this.scenePanel = new EditPanel_Scene(
      this.manager,
      this.selectIndex === 0 ? true : false
    );
    this.scenePanel.initPanel(container2);
    this.panels.push(this.scenePanel);

    // 地形编辑面板
    this.terrainPanel = new EditPanel_Terrain(
      this.manager,
      this.selectIndex === 1 ? true : false
    );
    this.terrainPanel.initPanel(container2);
    this.panels.push(this.terrainPanel);

    // 材质库面板
    this.materialPanel = new EditPanel_Material(
      this.manager,
      this.selectIndex === 2 ? true : false
    );
    this.materialPanel.initPanel(container2);
    this.panels.push(this.materialPanel);

    // 模型库面板
    this.modelPanel = new EditPanel_Model(
      this.manager,
      this.selectIndex === 3 ? true : false
    );
    this.modelPanel.initPanel(container2);
    this.panels.push(this.modelPanel);

    // 道路面板
    this.wayPanel = new EditPanel_Way(
      this.manager,
      this.selectIndex === 4 ? true : false
    );
    this.wayPanel.initPanel(container2);
    this.panels.push(this.wayPanel);

    if (!this._visible) {
      this.hide();
      //this.manager.interface.setClickMode(2);
    }
  }
  closePanel() {
    super.closePanel();

    this.panels[this.selectIndex].closePanel();
  }

  onClickBtn(obj, index) {
    this.panels[this.selectIndex].closePanel();

    this.uiObjs[this.selectIndex].material.opacity = 0.0;
    this.selectIndex = index;

    this.panels[this.selectIndex].show();
  }

  /**
   * 打开编辑面板
   * @param {*} subPanel "None"/"sceneModel"/"Terrain"/"Material"/"Model"/"Way"
   */
  show(subPanel = "None") {
    super.show();

    if (subPanel === "None") {
      this.panels[this.selectIndex].show();
      return;
    }

    let index = 0;
    switch (subPanel) {
      case "sceneModel":
        index = 0;
        break;
      case "Terrain":
        index = 1;
        break;
      case "Material":
        index = 2;
        break;
      case "Model":
        index = 3;
        break;
      case "Way":
        index = 4;
        break;
    }
    if (index !== this.selectIndex) {
      this.tabControl.setDefaultIndex(index);
    }
  }

  // -------------------------------接口函数，给外部调用
  /**
   * 场景模型模式选中模型
   * @param {*} model
   */
  setSelectModel(model) {
    if (this.scenePanel) this.scenePanel.setSelectModel(model);
  }

  updateModelValue() {
    if (this.scenePanel) this.scenePanel.updateUIValue();
  }

  /**
   * 模型库模式选中场景中的材质
   * @param {*} material
   */
  setSelectMaterial(material) {
    if (this.materialPanel) this.materialPanel.setSelectMat(material);
  }

  setModellibDefault() {
    if (this.modelPanel) this.modelPanel.setDefault();
  }
}
